
	<ng-container *ngIf="sensorName == '' else assetDetails">
		<span>No Asset Selected</span>
	</ng-container>
	<ng-template #noAsset></ng-template>
	<ng-template #assetDetails>
		<!-- Show the Event Info for the Asset -->
		<ng-container *ngIf="fromEvent then AssetEventInfo"></ng-container>

		<!-- Show the buttons for the Asset -->
		<!-- <ng-container *ngIf="(selectedAsset && (correctLocation || fromEvent)) then AssetButtons"></ng-container> -->

		<!-- Show the actual Graph Component -->
		<ng-container *ngIf="(correctLocation || fromEvent) then appAssetChart"></ng-container>

		<!-- <ejs-tab *ngIf="correctLocation || fromEvent" id="element" style="margin-top: var(--default-margin);"
			(selecting)="select($event)">
			<e-tabitems>
				<e-tabitem>
					<ng-template #headerText>
						<span class="alignRow">
							<mat-icon class="tab-icon">analytics</mat-icon>&nbsp;Trending
						</span>
					</ng-template>
					<ng-template #content>
						<ng-container *ngTemplateOutlet="tab1"></ng-container>
					</ng-template>
				</e-tabitem>
				<e-tabitem>
					<ng-template #headerText>
						<span class="alignRow">
							<mat-icon class="tab-icon">visibility</mat-icon>&nbsp;Watch List Information
						</span>
					</ng-template>
					<ng-template #content>
						<ng-container *ngIf="selectedAsset then tab2"></ng-container>
					</ng-template>
				</e-tabitem>
				<e-tabitem>
					<ng-template #headerText>
						<span class="alignRow">
							<mat-icon class="tab-icon">sensors</mat-icon>&nbsp;DataPoints
						</span>
					</ng-template>
					<ng-template #content>
						<ng-container *ngIf="selectedAsset then datapointsTab"></ng-container>
					</ng-template>
				</e-tabitem>
				<e-tabitem>
					<ng-template #headerText>
						<span class="alignRow">
							<mat-icon class="tab-icon">rule</mat-icon>&nbsp;Rules
						</span>
					</ng-template>
					<ng-template #content>
						<ng-container *ngIf="selectedAsset then rulesTab"></ng-container>
					</ng-template>
				</e-tabitem> -->
		<!-- <e-tabitem>
					<ng-template #headerText>
						<mat-icon class="tab-icon">timeline</mat-icon>Timeline
					</ng-template>
					<ng-template #content>
						<ng-container *ngTemplateOutlet="tab3"></ng-container>
					</ng-template>
				</e-tabitem>
				<e-tabitem>
					<ng-template #headerText>
						<mat-icon class="tab-icon">assessment</mat-icon>Statistics
					</ng-template>
					<ng-template #content>
						<ng-container *ngTemplateOutlet="tab4"></ng-container>
					</ng-template>
				</e-tabitem>
				<e-tabitem>
					<ng-template #headerText>
						<mat-icon class="tab-icon">group_work</mat-icon>Groups
					</ng-template>
					<ng-template #content>
						<ng-container *ngTemplateOutlet="tab5"></ng-container>
					</ng-template>
				</e-tabitem> -->
		<!-- </e-tabitems>
		</ejs-tab> -->

		<!-- <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="0ms">
			<mat-tab style="height: 100%;padding: 0px">
				<ng-template mat-tab-label><mat-icon class="tab-icon">analytics</mat-icon>&nbsp;Trending</ng-template>
				<ng-container style="background-color: green;" *ngTemplateOutlet="tab1"></ng-container>
			</mat-tab>
			<mat-tab *ngIf="!fromEvent">
				<ng-template mat-tab-label><mat-icon class="tab-icon">info</mat-icon>&nbsp;Details</ng-template>
				<ng-container *ngIf="selectedAsset then tab2"></ng-container>
			</mat-tab>
			<mat-tab>
				<ng-template mat-tab-label><mat-icon class="tab-icon">timeline</mat-icon>Timeline</ng-template>
				<ng-container *ngTemplateOutlet="tab3"></ng-container>
			</mat-tab>
			<mat-tab>
				<ng-template mat-tab-label><mat-icon class="tab-icon">assessment</mat-icon>Statistics</ng-template>
				<ng-container *ngTemplateOutlet="tab4"></ng-container>
			</mat-tab>
			<mat-tab>
				<ng-template mat-tab-label><mat-icon class="tab-icon">group_work</mat-icon>Groups</ng-template>
				<ng-container *ngTemplateOutlet="tab5"></ng-container>
			</mat-tab>
		</mat-tab-group> -->
	</ng-template>


<ng-template #AssetEventInfo>
	<div class="event-asset" *ngIf="fromEvent">
		<div *ngIf="selectedAsset" class="event-asset-details">
			<span>Name:</span>
			<span>{{selectedAsset.Name}}</span>
			<span>Description:</span>
			<span>{{selectedAsset.Description}}</span>
			<span>AssetID:</span>
			<span>{{selectedAsset.AssetID}}</span>
			<span *ngIf="timeFrom && timeTo">Event Trigger Window: </span>
			<span *ngIf="timeFrom && timeTo" style="font-weight: bolder;">{{ getReadableTime(timeFrom) }} - {{
				getReadableTime(timeTo) }}</span>
		</div>
		<span class="toolbar-spacer"></span>
		<div class="event-asset-buttons">
			<button *ngIf="selectedAsset" mat-raised-button color="primary"
				(click)="goToFunctionalLocation(this.selectedAsset.AssetID)"
				title="View on the Function Locations page">
				<mat-icon>north_east</mat-icon>
				<span>Functional Location</span>
			</button>
			<button *ngIf="selectedAsset" mat-raised-button color="" (click)="goBack()">
				<mat-icon>arrow_back</mat-icon>
				<span>Back</span>
			</button>
			<button *ngIf="selectedAsset" mat-raised-button color="primary" routerLink="/event">
				<mat-icon>north_east</mat-icon>
				<span>Events</span>
			</button>
		</div>
	</div>
</ng-template>

<ng-template #AssetButtons>
	<div class="asset-detail-buttons">
		<button class="alignRow" mat-raised-button
			(click)="popUpDatapoints()"><mat-icon>sensors</mat-icon><span>DataPoints</span></button>
		<button class="alignRow" mat-raised-button
			(click)="popUpRules()"><mat-icon>rule</mat-icon><span>Rules</span></button>
		<button class="alignRow" mat-raised-button
			(click)="createAction()"><mat-icon>content_paste</mat-icon><span>Create
				Action</span></button>
		<button class="alignRow" mat-raised-button
			(click)="openAssetModels()"><mat-icon>auto_awesome</mat-icon><span>Asset Models</span></button>
		<button class="alignRow" mat-raised-button color="primary"
			(click)="compareAsset()"><mat-icon>stacked_line_chart</mat-icon><span>Compare
				Asset</span></button>
		<button class="alignRow" *ngIf="selectedAsset && selectedAsset.Watch"
			style="background-color: var(--watch-bg-color);" mat-raised-button
			(click)="popUpWatchList()"><mat-icon>visibility_on</mat-icon><span>Watch List
				Info</span></button>
		<button class="alignRow" *ngIf="selectedAsset && selectedAsset.Actioned"
			style="background-color: var(--action-bg-color);" mat-raised-button
			(click)="popUpActionList()"><mat-icon>content_paste</mat-icon><span>Actions</span></button>
		<span class="toolbar-spacer"></span>
		<button class="alignRow" *ngIf="selectedAsset" mat-raised-button
			(click)="popUpHistory()"><mat-icon>history</mat-icon><span>Event & Action
				History</span></button>
	</div>
</ng-template>

<ng-template #appAssetChart>
	<app-asset-charts *ngIf="selectedAsset" assetID="{{selectedAsset.AssetID}}"
		selectedOrganisationUID="{{selectedOrganisationUID}}"></app-asset-charts>
</ng-template>

<!-- <ng-template #tab2>
	<div style="padding-top: var(--default-padding);">
		<p><a class="navbar-brand"><span>Name: {{selectedAsset.Name}}</span></a></p>
		<p><a class="navbar-brand"><span>AssetID: {{selectedAsset.AssetID}}</span></a></p>
		<p><a class="navbar-brand"><span>Description: {{selectedAsset.Description}}</span></a></p>
	</div>
	<app-watch-list></app-watch-list>
</ng-template> -->

<!-- <ng-template #datapointsTab>
	<div class="listview-container">
		<ejs-listview [dataSource]='dataPoints' cssClass="e-list-template">
			<ng-template #template let-dataSource>
				<div class="ejs-listview-item listview-datapoint">
					<img class="image" (click)="viewImage(imagePathSensors() + dataSource.SensorID+'?'+dataSource.Modified)"
						src="{{imagePathSensors()}}{{dataSource.SensorID}}?{{dataSource.Modified}}"
						title="{{ dataSource.SensorName }}"
						onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'"
						[attr.x-contenttype]="'image/png'">
					<span class="detail">{{ dataSource.DPTitle }}</span>
					<span class="me-auto"></span>
					<div class="toggle" *ngIf="account.Admin || currentUser.AdminSite">
						<mat-slide-toggle color="primary" [checked]="dataSource.ShowOnChart" style="margin: auto;"
							labelPosition="before" (change)="patchAssetDataPoint(dataSource, $event)">Show On
							Chart</mat-slide-toggle>
					</div>
				</div>
			</ng-template>
		</ejs-listview>
	</div>
</ng-template> -->

<!-- <ng-template #rulesTab>
	<nav class="location-title">
		<span>Asset Rules: </span>
		<span class="toolbar-spacer"></span>
		<span class="app-icon app-icon--add" (click)="createRule(selectedAsset)" matTooltip="Create New Rule" style="float: right;">
			<mat-icon />
		</span>
	</nav>
	<div style="height: 38vh; overflow-y: auto;">
		<ejs-splitter #horizontal height="calc(100% - var(--navBar-Height))" separatorSize=4 width='100%'
			*ngIf="assetRules && assetRules[0].RuleID != 0">
			<e-panes>
				<e-pane size='50%' min='30%'>
					<ng-template #content>
						<div class=" content-body">
							<ejs-accordion>
								<e-accordionitems>
									<e-accordionitem *ngFor="let rule of assetRules" [expanded]="false">
										<ng-template #header>
											<div style="text-decoration: underline; width: 100%;" class="alignRow"
												(click)="selectRule(rule)">
												<mat-icon *ngIf="rule.Active"
													style="margin-right: 0.5em; color: red;">notifications_active</mat-icon>
												<span>{{ rule.RuleDescription }}</span>
											</div>
										</ng-template>
										<ng-template #content>
											<nav>
												<span style="font-weight: bolder; min-width: 30%;">Rule
													Information:</span>
												<div style="float: right; cursor: pointer; display: flex;">
													<span *ngIf="rule.CreatedByUserID"
														style="margin-right: 3em;">Created By:
														{{rule.CreatedByUserID}}</span>
													<span style="margin-right: 3em;">Rule ID: {{rule.RuleID}}</span>
													<div style="margin-right: 3em;">
														<mat-slide-toggle *ngIf="account.Admin || currentUser.AdminSite"
															[checked]="rule.RuleEnabled"
															(change)="OnRuleEnable(rule, $event)"
															color="primary">Enabled</mat-slide-toggle>
													</div>
													<span class="app-icon app-icon--edit">
														<mat-icon *ngIf="account.Admin || currentUser.AdminSite"
															matTooltip="Edit Rule" (click)="onEditRule(rule, $event)" />
													</span>
													<span class="app-icon app-icon--delete">
														<mat-icon *ngIf="account.Admin || currentUser.AdminSite"
															matTooltip="Delete Rule"
															(click)="onDeleteRule(rule, $event)" />
													</span>
												</div>
											</nav>
											<div class="rule-info" [ngClass]="{'rule-active': rule.Active}">
												<span>Trigger Time:</span>
												<span>
													<span *ngIf="convertMinutesToHHMM(rule.TriggerTime)[0] != '00'">
														{{ convertMinutesToHHMM(rule.TriggerTime)[0] }} Hours and
													</span>
													<span *ngIf="rule.TriggerTime > 1">{{
														convertMinutesToHHMM(rule.TriggerTime)[1] }} Minutes</span>
													<span *ngIf="rule.TriggerTime == 1">{{
														convertMinutesToHHMM(rule.TriggerTime)[1] }} Minute</span>
												</span>
												<span></span>
												<span></span>
												<span>Rule Explanation:</span>
												<span style="text-decoration: underline;">DataPoint</span>
												<span style="text-decoration: underline;">Operator</span>
												<span style="text-decoration: underline;">Limit</span>
												<span>RULE WILL TRIGGER IF</span>
												<div *ngFor="let s of explainRule(rule); let i = index">
													<div [ngClass]="{'grid-def': ((i+1) % 4) != 0 }">
														<span>{{ s }}</span>
													</div>
												</div>
												<span>FOR</span>
												<span class="grid-def">{{ convertMinutesToHHMM(rule.TriggerTime)[0]
													}}:{{
													convertMinutesToHHMM(rule.TriggerTime)[1] }}</span>
											</div>
										</ng-template>
									</e-accordionitem>
								</e-accordionitems>
							</ejs-accordion>
						</div>
					</ng-template>
				</e-pane>
				<e-pane size='50%' min='10%'>
					<ng-template #content>
						<div class="events-list-div" *ngIf="selectedRule">
							<span *ngIf="selectedRule" style="font-size: large; font-weight: bolder;">Rule: {{
								selectedRule.RuleDescription }}</span>
							<br>
							<div class="top-div">
								<span style="font-size: large; font-weight: bolder;">Event History</span>
							</div>
							<div class="rule-events-list">
								<span>Timestamp</span>
								<span>Conditions</span>
								<span>Values</span>
							</div>
							<ejs-listbox [dataSource]='filteredRuleEvents' [fields]="fields" class="listbox-container"
								[allowFiltering]="true" filterBarPlaceholder="Search for an Event" filterType="contains"
								(filtering)="onFiltering($event)">
								<ng-template #itemTemplate let-data>
									<div class="rule-events-list ejs-listbox-item" (click)="GoToEvent(data)">
										<span style="font-weight: bolder;">{{ getDate(data.TimeStamp) }}</span>
										<span> {{ data.RuleText }}</span>
										<span>{{ data.RuleValues }}</span>
									</div>
								</ng-template>
							</ejs-listbox>
						</div>
					</ng-template>
				</e-pane>
			</e-panes>
		</ejs-splitter>
		<div class="location-title" *ngIf="assetRules && assetRules[0].RuleID == 0">
			<span>This Asset Has No Rules</span>
		</div>
	</div>
</ng-template> -->

<!-- <ng-template #tab3>
	<nav class="navbar navbar-expand-lg alignRow" style="height: var(--navBar-Height);">
		<div><a class="navbar-brand"><span>{{sensorName}} Timeline</span></a></div>
	</nav>
</ng-template> -->

<!-- <ng-template #tab4>
	<nav class="navbar navbar-expand-lg alignRow" style="height: var(--navBar-Height);">
		<div><a class="navbar-brand"><span>{{sensorName}} Statistics</span></a></div>
	</nav>
</ng-template> -->

<!-- <ng-template #tab5>
	<nav class="navbar navbar-expand-lg alignRow" style="height: var(--navBar-Height);">
		<div><a class="navbar-brand"><span>{{sensorName}} Groups</span></a></div>
	</nav>
</ng-template> -->